// storage.js
export const storage = {
  // 设置存储
  set(key, value) {
    localStorage.setItem(key, JSON.stringify(value))
  },
  
  // 获取存储
  get(key) {
    const value = localStorage.getItem(key)
    return value ? JSON.parse(value) : null
  },
  
  // 移除存储
  remove(key) {
    localStorage.removeItem(key)
  },
  
  // 清空所有存储
  clear() {
    localStorage.clear()
  },
  
  // 检查是否存在
  has(key) {
    return localStorage.getItem(key) !== null
  }
}

// 存储事件监听器
export function setupStorageListener(callback) {
  window.addEventListener('storage', (event) => {
    console.log('Storage changed:', event.key, event.newValue)
    if (callback) {
      callback(event.key, event.newValue ? JSON.parse(event.newValue) : null)
    }
  })
}